import notifyingAction from "domainActions/notifyingAction";
import {
  createTeam,
  loadTeam,
  updateTeam,
  deleteTeam,
  addMembers as addMembersFn,
  addMemberToTeams as addMemberToTeamsFn,
  addRoleToTeams as addRoleToTeamsFn,
  removeMember as removeMemberFn,
  removeRole as removeRoleFn,
  loadUsersForTeam as loadUsersForTeamFn,
  loadRolesForTeam as loadRolesForTeamFn,
  loadTeamsForUser as loadTeamsForUserFn,
  loadTeamsForRole as loadTeamsForRoleFn,
  loadTeamsPaginated as loadTeamsPaginatedFn,
  loadTeamSharesPaginated as loadTeamSharesPaginatedFn
} from "../api/teams";
const create = notifyingAction({
  action: createTeam,
  success: (team) => ({
    message: `Team "${team == null ? void 0 : team.name}" was created successfully`
  }),
  error: (error, team) => ({
    message: `Creating team "${team == null ? void 0 : team.name}" failed with status: ${error}`
  })
});
const load = notifyingAction({
  action: loadTeam,
  error: (error, teamId) => ({
    message: `Loading team with id "${teamId}" failed with status: ${error}`
  }),
  notFoundRedirect: true
});
const update = notifyingAction({
  action: updateTeam,
  success: (team) => ({
    message: `Team "${team.name}" was updated successfully`
  }),
  error: (error, team) => ({
    message: `Updating team "${team.name}" failed with status: ${error}`
  })
});
const deleteAction = notifyingAction({
  action: deleteTeam,
  success: (team) => ({
    message: `Team "${team.name}" was deleted successfully`
  }),
  error: (error, team) => ({
    message: `Deleting team "${team.name}" failed with status: ${error}`
  })
});
const addMembers = notifyingAction({
  action: addMembersFn,
  success: (_teamId, userIds) => ({
    message: `${userIds.size} users were assigned successfully`
  }),
  error: (error, _teamId, userIds) => ({
    message: `Assigning ${userIds.size} users failed with status: ${error}`
  })
});
const addMemberToTeams = notifyingAction({
  action: addMemberToTeamsFn,
  success: () => ({
    message: "User was assigned successfully"
  }),
  error: (error, userId) => ({
    message: `Assigning user with id "${userId}" failed with status: ${error}`
  })
});
const addRoleToTeams = notifyingAction({
  action: addRoleToTeamsFn,
  success: () => ({
    message: "Teams were assigned to role successfully"
  }),
  error: (error, roleId) => ({
    message: `Assigning team to role with id "${roleId}" failed with status: ${error}`
  })
});
const removeMember = notifyingAction({
  action: removeMemberFn,
  success: () => ({
    message: "User was unassigned successfully"
  }),
  error: (error) => ({
    message: `Unassign user failed with status: ${error}`
  })
});
const removeRole = notifyingAction({
  action: removeRoleFn,
  success: () => ({
    message: "Team was unassigned from role successfully"
  }),
  error: (error) => ({
    message: `Unassign team form role failed with from status: ${error}`
  })
});
const loadUsersForTeam = notifyingAction({
  action: loadUsersForTeamFn,
  error: (error, _teamId, teamName) => ({
    message: `Loading users for team "${teamName}" failed with status: ${error}`
  })
});
const loadRolesForTeam = notifyingAction({
  action: loadRolesForTeamFn,
  error: (error, _teamId, teamName) => ({
    message: `Loading roles for team "${teamName}" failed with status: ${error}`
  })
});
const loadTeamsForUser = notifyingAction({
  action: loadTeamsForUserFn,
  error: (error, userId) => ({
    message: `Loading teams for user "${userId}" failed with status: ${error}`
  })
});
const loadTeamsForRole = notifyingAction({
  action: loadTeamsForRoleFn,
  error: (error, userId) => ({
    message: `Loading teams for user "${userId}" failed with status: ${error}`
  })
});
const loadTeamsPaginated = notifyingAction({
  action: loadTeamsPaginatedFn,
  error: (error) => ({
    message: `Loading teams failed with status: ${error}`
  })
});
const loadTeamSharesPaginated = notifyingAction({
  action: loadTeamSharesPaginatedFn,
  error: (error, teamId) => ({
    message: `Loading entities which got shared with team with id "${teamId}" failed with status: ${error}`
  })
});
export default {
  create,
  load,
  update,
  delete: deleteAction,
  addMembers,
  addMemberToTeams,
  addRoleToTeams,
  removeMember,
  removeRole,
  loadUsersForTeam,
  loadRolesForTeam,
  loadTeamsForUser,
  loadTeamsForRole,
  loadTeamsPaginated,
  loadTeamSharesPaginated
};
